

import CommonApi from './../commonApi';

const budgetLineItem = new CommonApi(
  'budgetLineItem',
  'статья бюджетной формы'
);

export default budgetLineItem;
